import { Button, Flex, Text } from "@radix-ui/themes";
import { ReactNode } from "react";

interface ScoreCardProps {
  score: number;
  totalScore: number;
  minimumScore: string;
  findingResult: string | ReactNode;
  assessmentType: string | undefined;
  handleSubmit: () => void;
}

const ScoreCard = ({
  score,
  totalScore,
  findingResult,
  assessmentType,
  minimumScore,
  handleSubmit,
}: ScoreCardProps) => {
  let findScoreStatus =
    score >= Number(minimumScore) ? "text-green-700" : "text-red-700";
  return (
    <div>
      <div className="h-50 w-80 bg-gray-200 py-6 px-16 my-4 mx-4 rounded-3xl shadow-lg">
        <Flex className="w-full p-1 px-2">
          <Text className="px-4 text-purple-700 text-xl font-semibold">Marks Scored</Text>
        </Flex>
        <Flex className="w-full px-4 items-center">
          <Text className={`px-4 font-bold text-4xl ${findScoreStatus}`}>
            {score}
          </Text>
          <div className="font-bold text-4xl py-0.5">/</div>
          <Text className="px-4 font-bold text-4xl text-gray-600"> {totalScore} </Text>
        </Flex>
        <Flex className="w-full px-2 flex-col items-center mt-4">
          {assessmentType === "test" && (
            <Text className="text-purple-700 text-xl font-semibold">Result</Text>
          )}
          <Text className={`text-4xl font-bold ${findScoreStatus}`}>
            {findingResult}
          </Text>
        </Flex>
      </div>
      <div className="">
        <Button
          color="purple"
          variant="solid"
          size="3"
          className="w-20"
          onClick={() => handleSubmit()}
        >
          Ok
        </Button>
      </div>
    </div>
  );
};

export default ScoreCard;
